import { render } from "./BlStandaloneSortableItem.vue?vue&type=template&id=4d7d8155"
import script from "./BlStandaloneSortableItem.vue?vue&type=script&lang=js"
export * from "./BlStandaloneSortableItem.vue?vue&type=script&lang=js"

import exportComponent from "/tmp/4f365a42-b3f2-4061-98cc-f7413900e2b1/frontend/core/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__